import { Box, Divider, Typography } from "@mui/material";
import type React from "react";
import { useSelector } from "react-redux";
import { RootState } from "../../../../../../../../store/Index";
import { Proposal } from "../../../../../types/proposal.types";

interface ProposalServicesPageProps {
  proposal: Proposal;
}

const ProposalServicesPageUpdated: React.FC<ProposalServicesPageProps> = ({
  proposal,
}) => {
  const reduxTheme = useSelector((state: RootState) => state.theme);

  return (
    <Box
      id="proposal-services-page"
      sx={{
        p: 6,
        pageBreakBefore: "always",
      }}
    >
      {/* Header */}
      <Typography
        variant="h5"
        sx={{ fontWeight: 700, mb: 3, color: reduxTheme.primary_colors[400] }}
      >
        Proposed Services
      </Typography>

      {/* Selected Package */}
      {proposal.package && (
        <Box
          sx={{
            mb: 3,
            p: 3,
            borderRadius: 2,
            border: `2px solid ${reduxTheme.primary_colors[400]}`,
          }}
        >
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              mb: 2,
            }}
          >
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              <Typography
                variant="h6"
                sx={{
                  fontWeight: 700,
                  color: reduxTheme.primary_colors[400],
                }}
              >
                {proposal.package.name}
              </Typography>
              {/* {proposal.package.recommended && (
                <Chip label="Recommended" color="primary" size="small" />
              )} */}
            </Box>
            <Typography
              variant="h6"
              sx={{ fontWeight: 700, color: reduxTheme.primary_colors[400] }}
            >
              ${proposal.package.base_price}
            </Typography>
          </Box>
          <Typography variant="body2" sx={{ fontWeight: 600, mb: 1 }}>
            Package Includes:
          </Typography>
          {/* <Box component="ul" sx={{ m: 0, pl: 2 }}>
            <Typography variant="body2">
              {proposal.package.content}
            </Typography> 
          </Box> */}
        </Box>
      )}

      {/* Additional Services */}
      {proposal.package &&
        proposal.services &&
        proposal.services.length > 0 && (
          <Typography
            variant="subtitle1"
            sx={{ fontWeight: 600, mb: 2, mt: 3 }}
          >
            Additional Services
          </Typography>
        )}

      {proposal.services?.map((ps, index) => (
        <Box
          key={index}
          sx={{ mb: 3, p: 2, bgcolor: "#f9f9f9", borderRadius: 1 }}
        >
          <Box sx={{ display: "flex", justifyContent: "space-between", mb: 1 }}>
            <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
              {ps.name}
            </Typography>
            <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
              ${(ps.price).toLocaleString()}
            </Typography>
          </Box>
          <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
            {ps.description}
          </Typography>
          {/* {ps.service.features && (
            <Box sx={{ mb: 1 }}>
              {ps.service.features.map((feature, idx) => (
                <Chip
                  key={idx}
                  label={feature}
                  size="small"
                  sx={{ mr: 0.5, mb: 0.5, fontSize: "0.7rem" }}
                />
              ))}
            </Box>
          )} */}
          {/* {ps.customizations && (
            <Typography variant="body2" sx={{ fontStyle: "italic", mt: 1 }}>
              <strong>Customizations:</strong> {ps.customizations}
            </Typography>
          )}
          <Typography variant="body2" sx={{ mt: 1 }}>
            <strong>Quantity:</strong> {ps.quantity}
          </Typography> */}
        </Box>
      ))}

      {/* Totals */}
      <Box sx={{ mt: 4, pt: 2, borderTop: 2, borderColor: "divider" }}>
        <Box sx={{ display: "flex", justifyContent: "space-between", mb: 1 }}>
          <Typography variant="h6" sx={{ fontWeight: 700 }}>
            Total:
          </Typography>
          <Typography variant="h6" sx={{ fontWeight: 700 }}>
            {proposal.estimateTotal}
          </Typography>
        </Box>
        {/* <Box sx={{ display: "flex", justifyContent: "space-between", mb: 2 }}>
          <Typography variant="body1">Tax (8%):</Typography>
          <Typography variant="body1" sx={{ fontWeight: 600 }}>
            ${proposal.tax.toLocaleString()}
          </Typography>
        </Box> */}
        {/* <Divider sx={{ mb: 2 }} />
        <Box sx={{ display: "flex", justifyContent: "space-between" }}>
          <Typography variant="h6" sx={{ fontWeight: 700 }}>
            Total:
          </Typography>
          <Typography variant="h6" sx={{ fontWeight: 700 }}>
            ${proposal.total.toLocaleString()}
          </Typography>
        </Box> */}
      </Box>

      <Box sx={{ mt: 4, p: 2, bgcolor: "#f5f5f5", borderRadius: 1 }}>
        <Typography variant="subtitle2" sx={{ fontWeight: 600, mb: 1 }}>
          Terms and Conditions
        </Typography>
        <Typography variant="body2" sx={{ whiteSpace: "pre-wrap" }}>
          {proposal.terms_and_conditions}
        </Typography>
      </Box>

      {/* Signatures */}
      <Box sx={{ display: "flex", justifyContent: "space-between", mt: 6 }}>
        <Box sx={{ width: "45%" }}>
          <Divider sx={{ mb: 1 }} />
          <Typography variant="body2">Client Signature</Typography>
          <Typography variant="body2" color="text.secondary">
            Date
          </Typography>
        </Box>
        <Box sx={{ width: "45%" }}>
          <Divider sx={{ mb: 1 }} />
          <Typography variant="body2">Muzukuru Representative</Typography>
          <Typography variant="body2" color="text.secondary">
            Date
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default ProposalServicesPageUpdated;
